import { Avatar } from '@mui/joy';
import { CircularProgress } from '@mui/material';
import { upperFirst } from 'lodash';
import moment from 'moment/moment';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { pictos } from '../assets/img/pictos';
import Chemin from '../components/Chemin';
import ErrorPopup from '../components/ErrorPopup';
import Navigation from '../components/Navigation';
import { NotifNbreContext } from '../Context';
import { PoliceDefaut } from '../helpers/contants';
import { programmeSelectRedux } from '../redux/evenementsServices';
import {
  NotificationsRedux,
  accepterDemandeRedux,
  chatSelect,
  contactsRedux,
  demandesRedux,
  invitationsRedux,
  refreshToken,
  refuserDemandeRedux,
  validerRdv,
} from '../redux/profilService';
import { addHistorique, addRdv } from '../redux/profilSlice';
import {
  ArchiveNotification,
  MarkAllNotificationsRead,
  UpdateNotification,
} from '../redux/updatesServices';
import '../styles/contacts.css';
import textConnect from '../textConnect.json';
import { chatSelected, formatName } from './fonctions';

const FILTER_ALL = 'all';
const FILTER_UNREAD = 'unread';

const NotificationsPage = () => {
  const monProfil = useSelector(state => state.profil.profil);
  const listeNotifications = useSelector(state => state.profil.notifications);
  const accessToken = useSelector(state => state.user.access);
  const refresh_token = useSelector(state => state.user.refresh);
  const [selectedFilter, setSelectedFilter] = useState(FILTER_ALL);
  const [localNotifications, setLocalNotifications] = useState([]);

  const dispatch = useDispatch();
  const navigationPage = useNavigate();

  const nbreNotif = useContext(NotifNbreContext);

  const [openRefuserDemande, setOpenRefuserDemande] = useState(false);
  const [selectInvitation, setSelectInvitation] = useState();
  const [selectNotif, setSelectNotif] = useState();
  const [selectRdvItem, setSelectRdvItem] = useState(null);

  const [netStatus, setNetStatus] = useState(() => {
    if (navigator.onLine) {
      console.log('Connected to network.');
      return true;
    } else {
      return false;
    }
  });

  useEffect(() => {
    window.ononline = e => {
      console.log('Connected to network.');
      setNetStatus(true);
    };
    window.onoffline = e => {
      console.log('Network connection lost.');
      setNetStatus(false);
    };
  }, [netStatus]);

  const ouvrirRefuser = (id, id_notif, item = null) => {
    // #region agent log
    fetch('http://localhost:7244/ingest/3effbe86-96a9-4765-ae52-abee6021f624', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        location: 'NotificationsPage.js:ouvrirRefuser',
        message: 'ouvrirRefuser called',
        data: {
          id_target: id,
          id_notif,
          typeofId: typeof id,
          isNull: id === null,
          isUndefined: id === undefined,
        },
        timestamp: Date.now(),
        hypothesisId: 'H1-H4',
      }),
    }).catch(() => {});
    // #endregion
    setSelectInvitation(id);
    setSelectNotif(id_notif);
    setSelectRdvItem(item?.data_target ? item : null);
    setOpenRefuserDemande(true);
    // console.log(id)
  };
  const [openError, setOpenError] = useState(false);
  const [msgError, setMsgError] = useState('');
  const closeErrorHandle = () => {
    setOpenError(false);
  };

  const [circle, setCircle] = useState(false);
  const messageHandle = (
    nom,
    prenom,
    fonction,
    idChat,
    photoChat,
    organisationContact,
    photoOrganisation,
    roomChat,
    id_notif,
    structureChat
  ) => {
    setLoading(true);
    UpdateNotification(id_notif, accessToken)
      .then(reponse => {
        chatSelect(
          chatSelected(
            nom,
            prenom,
            fonction,
            idChat,
            photoChat,
            organisationContact,
            photoOrganisation,
            structureChat
          ),
          dispatch,
          navigationPage,
          `/chat/${idChat}/${roomChat}/1`,
          accessToken,
          setLoading
        );
        NotificationsRedux(accessToken).then(reponse => {
          dispatch({
            type: 'Profil/addNotifications',
            payload: reponse.data.filter(
              item => item.participant_recepteur.id === monProfil.id && item.etat === false
            ),
          });
          nbreNotif.setNbre(
            reponse.data.filter(
              item => item.participant_recepteur.id === monProfil.id && item.etat === false
            ).length
          );
        });
      })
      .catch(erreur => {
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');

              setLoading(false);
              messageHandle(
                nom,
                prenom,
                fonction,
                idChat,
                photoChat,
                organisationContact,
                photoOrganisation,
                roomChat,
                id_notif,
                structureChat
              );
            });
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
  };
  // eslint-disable-next-line no-unused-vars
  const rdvHandle = (id_notif, rdv) => {
    setLoading(true);
    if (rdv.data_target !== null) {
      // console.log(rdv)
      try {
        dispatch(addRdv(rdv));
        navigationPage('/rendezvous');
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    } else {
      UpdateNotification(id_notif, accessToken)
        .then(reponse => {
          // console.log(reponse)
          setLoading(false);
          // console.log(listeNotifications.filter(item => item.participant_recepteur.id === monProfil.id && item.etat === false))
          NotificationsRedux(accessToken).then(reponse => {
            dispatch({
              type: 'Profil/addNotifications',
              payload: reponse.data.filter(
                item => item.participant_recepteur.id === monProfil.id && item.etat === false
              ),
            });

            nbreNotif.setNbre(
              reponse.data.filter(
                item => item.participant_recepteur.id === monProfil.id && item.etat === false
              ).length
            );
          });
        })
        .catch(erreur => {
          setLoading(false);
          if (!netStatus) {
            setMsgError(textConnect.internet);
            setOpenError(true);
          }
          if (erreur.response) {
            if (erreur.response.status !== 401) {
              setMsgError(textConnect.error);
              setOpenError(true);
            }
            if (erreur.response.status === 401) {
              refreshToken(refresh_token).then(async reponse => {
                dispatch({
                  type: 'user/addRefresh',
                  payload: reponse.data.refresh,
                });
                dispatch({
                  type: 'user/addAccess',
                  payload: reponse.data.access,
                });
                console.log('token refresh...');

                setLoading(false);
                UpdateNotification(id_notif, accessToken);
              });
            }
          } else {
            setMsgError(textConnect.internet);
            setOpenError(true);
          }
        });
    }
  };

  const accepterHandle = (idInvitation, id_notif) => {
    setLoading(true);
    if (idInvitation === '' || idInvitation === undefined) {
      UpdateNotification(id_notif, accessToken, { choix: 'ACCEPTED' })
        .then(() => {
          setLocalNotifications(prev =>
            prev.map(n => (n.id === id_notif ? { ...n, choix: 'ACCEPTED' } : n))
          );
          fetchNotifications(selectedFilter);
          setLoading(false);
        })
        .catch(erreur => {
          setLoading(false);
          if (!netStatus) {
            setMsgError(textConnect.internet);
            setOpenError(true);
          } else {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
        });
      return;
    }

    accepterDemandeRedux(accessToken, idInvitation)
      .then(reponse => {
        contactsRedux(accessToken).then(reponse => {
          dispatch({ type: 'Profil/addContacts', payload: reponse.data });
          demandesRedux(accessToken).then(reponse => {
            dispatch({ type: 'Profil/addDemandes', payload: reponse.data });
          });
          invitationsRedux(accessToken).then(reponse => {
            dispatch({ type: 'Profil/addInvitations', payload: reponse.data });
          });
        });

        UpdateNotification(id_notif, accessToken, { choix: 'ACCEPTED' })
          .then(() => {
            setLocalNotifications(prev =>
              prev.map(n => (n.id === id_notif ? { ...n, choix: 'ACCEPTED' } : n))
            );
            fetchNotifications(selectedFilter);
            setLoading(false);
          })
          .catch(erreur => {
            setLoading(false);
            if (!netStatus) {
              setMsgError(textConnect.internet);
              setOpenError(true);
            }
          });
      })
      .catch(erreur => {
        setLoading(false);
        if (
          erreur.response?.status === 409 &&
          erreur.response?.data?.code === 'ALREADY_PROCESSED'
        ) {
          setLocalNotifications(prev =>
            prev.map(n => (n.id === id_notif ? { ...n, choix: 'ALREADY_PROCESSED' } : n))
          );
          UpdateNotification(id_notif, accessToken).catch(() => {});
          setMsgError(erreur.response.data.message || 'Cette demande a déjà été traitée');
          setOpenError(true);
        } else if (erreur.response?.status === 401) {
          refreshToken(refresh_token).then(async reponse => {
            dispatch({ type: 'user/addRefresh', payload: reponse.data.refresh });
            dispatch({ type: 'user/addAccess', payload: reponse.data.access });
            accepterHandle(idInvitation, id_notif);
          });
        } else if (netStatus) {
          setMsgError(textConnect.error);
          setOpenError(true);
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
  };
  const rdvAccepterHandle = item => {
    if (!item?.data_target?.id_programme) return;
    setLoading(true);
    validerRdv(item.data_target.id_programme, monProfil.id, accessToken, 'accepter')
      .then(() => {
        UpdateNotification(item.id, accessToken, { choix: 'ACCEPTED' }).then(() => {
          setLocalNotifications(prev =>
            prev.map(n => (n.id === item.id ? { ...n, choix: 'ACCEPTED' } : n))
          );
          fetchNotifications(selectedFilter);
          setLoading(false);
        });
      })
      .catch(erreur => {
        setLoading(false);
        if (
          erreur.response?.status === 409 &&
          erreur.response?.data?.code === 'ALREADY_PROCESSED'
        ) {
          setLocalNotifications(prev =>
            prev.map(n => (n.id === item.id ? { ...n, choix: 'ALREADY_PROCESSED' } : n))
          );
          UpdateNotification(item.id, accessToken).catch(() => {});
          setMsgError(erreur.response.data.message || 'Cette demande a déjà été traitée');
          setOpenError(true);
        } else if (erreur.response?.status === 401) {
          refreshToken(refresh_token).then(reponse => {
            dispatch({ type: 'user/addRefresh', payload: reponse.data.refresh });
            dispatch({ type: 'user/addAccess', payload: reponse.data.access });
            rdvAccepterHandle(item);
          });
        } else if (netStatus) {
          setMsgError(textConnect.error);
          setOpenError(true);
        }
      });
  };
  const rdvRefuserHandle = item => {
    if (!item?.data_target?.id_programme) return;
    setCircle(true);
    validerRdv(item.data_target.id_programme, monProfil.id, accessToken, 'refuser')
      .then(() => {
        UpdateNotification(item.id, accessToken, { choix: 'REFUSED' }).then(() => {
          setCircle(false);
          setOpenRefuserDemande(false);
          setSelectRdvItem(null);
          setLocalNotifications(prev =>
            prev.map(n => (n.id === item.id ? { ...n, choix: 'REFUSED' } : n))
          );
          fetchNotifications(selectedFilter);
        });
      })
      .catch(erreur => {
        setCircle(false);
        if (
          erreur.response?.status === 409 &&
          erreur.response?.data?.code === 'ALREADY_PROCESSED'
        ) {
          setOpenRefuserDemande(false);
          setSelectRdvItem(null);
          setLocalNotifications(prev =>
            prev.map(n => (n.id === item.id ? { ...n, choix: 'ALREADY_PROCESSED' } : n))
          );
          UpdateNotification(item.id, accessToken).catch(() => {});
          setMsgError(erreur.response.data.message || 'Cette demande a déjà été traitée');
          setOpenError(true);
        } else if (erreur.response?.status === 401) {
          refreshToken(refresh_token).then(reponse => {
            dispatch({ type: 'user/addRefresh', payload: reponse.data.refresh });
            dispatch({ type: 'user/addAccess', payload: reponse.data.access });
            rdvRefuserHandle(item);
          });
        } else if (netStatus) {
          setMsgError(textConnect.error);
          setOpenError(true);
        }
      });
  };
  const refuserHandle = (idInvitation, id_notif) => {
    if (selectRdvItem) {
      rdvRefuserHandle(selectRdvItem);
      return;
    }
    setCircle(true);
    const noValidDemandeId =
      idInvitation == null || idInvitation === '' || idInvitation === undefined;
    if (noValidDemandeId) {
      UpdateNotification(id_notif, accessToken, { choix: 'REFUSED' })
        .then(() => {
          setCircle(false);
          setOpenRefuserDemande(false);
          setSelectRdvItem(null);
          setLocalNotifications(prev =>
            prev.map(n => (n.id === id_notif ? { ...n, choix: 'REFUSED' } : n))
          );
          fetchNotifications(selectedFilter);
        })
        .catch(erreur => {
          setCircle(false);
          if (!netStatus) {
            setMsgError(textConnect.internet);
            setOpenError(true);
          } else {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
        });
      return;
    }

    refuserDemandeRedux(accessToken, idInvitation)
      .then(reponse => {
        contactsRedux(accessToken).then(reponse => {
          dispatch({ type: 'Profil/addContacts', payload: reponse.data });
          demandesRedux(accessToken).then(reponse => {
            dispatch({ type: 'Profil/addDemandes', payload: reponse.data });
          });
          invitationsRedux(accessToken).then(reponse => {
            dispatch({ type: 'Profil/addInvitations', payload: reponse.data });
          });
        });

        UpdateNotification(id_notif, accessToken, { choix: 'REFUSED' })
          .then(() => {
            setCircle(false);
            setOpenRefuserDemande(false);
            setSelectRdvItem(null);
            setLocalNotifications(prev =>
              prev.map(n => (n.id === id_notif ? { ...n, choix: 'REFUSED' } : n))
            );
            fetchNotifications(selectedFilter);
          })
          .catch(erreur => {
            setCircle(false);
            if (!netStatus) {
              setMsgError(textConnect.internet);
              setOpenError(true);
            }
          });
      })
      .catch(erreur => {
        setCircle(false);
        if (
          erreur.response?.status === 409 &&
          erreur.response?.data?.code === 'ALREADY_PROCESSED'
        ) {
          setOpenRefuserDemande(false);
          setSelectRdvItem(null);
          setLocalNotifications(prev =>
            prev.map(n => (n.id === id_notif ? { ...n, choix: 'ALREADY_PROCESSED' } : n))
          );
          UpdateNotification(id_notif, accessToken).catch(() => {});
          setMsgError(erreur.response.data.message || 'Cette demande a déjà été traitée');
          setOpenError(true);
        } else if (erreur.response?.status === 401) {
          refreshToken(refresh_token).then(async reponse => {
            dispatch({ type: 'user/addRefresh', payload: reponse.data.refresh });
            dispatch({ type: 'user/addAccess', payload: reponse.data.access });
            refuserHandle(idInvitation, id_notif);
          });
        } else if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        } else {
          setMsgError(textConnect.error);
          setOpenError(true);
        }
      });
  };
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  //Breadcrumbs
  const breadCrumbs = useSelector(state => state.profil.chemin);
  const breadcrumbs_temp = breadCrumbs.filter(item => item.nom === 'Accueil');
  breadcrumbs_temp.push({ url: location.pathname, nom: 'Notifications' });
  const fetchNotifications = useCallback(
    (filter = selectedFilter) => {
      setLoading(true);
      NotificationsRedux(accessToken, filter)
        .then(reponse => {
          const filtered = reponse.data.filter(
            item => item.participant_recepteur.id === monProfil.id
          );
          setLocalNotifications(filtered);

          // Always update the unread count in Redux/context
          const unreadOnly = filtered.filter(item => item.etat === false);
          dispatch({
            type: 'Profil/addNotifications',
            payload: unreadOnly,
          });
          nbreNotif.setNbre(unreadOnly.length);
          setLoading(false);
        })
        .catch(erreur => {
          console.log('Error refreshing notifications on page load:', erreur);
          setLoading(false);
        });
    },
    [accessToken, monProfil?.id, selectedFilter, dispatch, nbreNotif]
  );

  const archiveHandle = useCallback(
    id_notif => {
      ArchiveNotification(id_notif, accessToken)
        .then(() => {
          setLocalNotifications(prev => prev.filter(n => n.id !== id_notif));
          // Refresh the unread count
          NotificationsRedux(accessToken, 'unread')
            .then(reponse => {
              const unread = reponse.data.filter(
                item => item.participant_recepteur.id === monProfil.id
              );
              dispatch({ type: 'Profil/addNotifications', payload: unread });
              nbreNotif.setNbre(unread.length);
            })
            .catch(() => {});
        })
        .catch(erreur => {
          console.log('Error archiving notification:', erreur);
        });
    },
    [accessToken, monProfil?.id, dispatch, nbreNotif]
  );

  const isNotificationRowClickable = item => {
    if (item.type === 'MESSAGE' || item.type === 'INVITATION_ACCEPTEE') return true;
    if (
      item.type === 'DEMANDE_RENDEZ_VOUS' ||
      (item.type === 'RELANCE_DEMANDE' && item.data_target)
    ) {
      if (item.detail === 'est indisponible pour ce rendez-vous' && item.id_target) return true;
      if (item.data_target != null) return true;
    }
    if (item.type === 'ACCEPTER_RENDEZ_VOUS') return true;
    return false;
  };

  const handleNotificationRowClick = item => {
    if (item.type === 'MESSAGE' || item.type === 'INVITATION_ACCEPTEE') {
      messageHandle(
        item.participant_emeteur.nom,
        item.participant_emeteur.prenom,
        item.participant_emeteur.fonction,
        item.id_target,
        item.participant_emeteur.photo,
        item.participant_emeteur.organisation.nom,
        item.participant_emeteur.organisation.logo,
        item.room,
        item.id,
        item.participant_emeteur.from_structure
      );
      return;
    }
    if (
      item.type === 'DEMANDE_RENDEZ_VOUS' ||
      (item.type === 'RELANCE_DEMANDE' && item.data_target)
    ) {
      if (item.detail === 'est indisponible pour ce rendez-vous' && item.id_target) {
        messageHandle(
          item.participant_emeteur.nom,
          item.participant_emeteur.prenom,
          item.participant_emeteur.fonction,
          item.id_target,
          item.participant_emeteur.photo,
          item.participant_emeteur.organisation.nom,
          item.participant_emeteur.organisation.logo,
          item.room,
          item.id,
          item.participant_emeteur.from_structure
        );
        return;
      }
      if (item.data_target != null) {
        UpdateNotification(item.id, accessToken).catch(() => {});
        if (item.choix === 'ACCEPTED' && item.data_target?.id_programme) {
          programmeSelectRedux(accessToken, item.data_target.id_programme)
            .then(response => {
              if (!response.data.intervenants?.length) {
                setMsgError("Ce rendez-vous n'existe plus ou a été supprimé.");
                setOpenError(true);
                return;
              }
              dispatch({ type: 'evenements/addProgrammeSelect', payload: response.data });
              navigationPage(`/programme/${item.data_target.id_programme}/2`);
              window.scrollTo(0, 0);
            })
            .catch(error => {
              if (!navigator.onLine) {
                setMsgError(textConnect.internet);
              } else if (error?.response?.status === 404) {
                setMsgError("Ce rendez-vous n'existe plus ou a été supprimé.");
              } else {
                setMsgError(textConnect.error);
              }
              setOpenError(true);
            });
        } else {
          navigationPage('/mes-rendez-vous');
        }
      }
      return;
    }
    if (item.type === 'ACCEPTER_RENDEZ_VOUS') {
      if (!item.data_target?.id_programme) {
        setMsgError("Ce rendez-vous n'existe plus ou a été supprimé.");
        setOpenError(true);
        return;
      }
      UpdateNotification(item.id, accessToken).catch(() => {});
      programmeSelectRedux(accessToken, item.data_target.id_programme)
        .then(response => {
          if (!response.data.intervenants?.length) {
            setMsgError("Ce rendez-vous n'existe plus ou a été supprimé.");
            setOpenError(true);
            return;
          }
          dispatch({ type: 'evenements/addProgrammeSelect', payload: response.data });
          navigationPage(`/programme/${item.data_target.id_programme}/2`);
          window.scrollTo(0, 0);
        })
        .catch(error => {
          if (!navigator.onLine) {
            setMsgError(textConnect.internet);
          } else if (error?.response?.status === 404) {
            setMsgError("Ce rendez-vous n'existe plus ou a été supprimé.");
          } else {
            setMsgError(textConnect.error);
          }
          setOpenError(true);
        });
      return;
    }
  };

  useEffect(() => {
    dispatch({
      type: 'Profil/addChemin',
      payload: breadcrumbs_temp,
    });
    dispatch(addHistorique('/'));

    fetchNotifications(selectedFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter]);

  // Re-fetch the local list whenever Redux notifications change (e.g. after actions)
  useEffect(() => {
    fetchNotifications(selectedFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listeNotifications.length]);

  // Mark all notifications as read when leaving the page
  useEffect(() => {
    return () => {
      MarkAllNotificationsRead(accessToken)
        .then(() => {
          NotificationsRedux(accessToken).then(reponse => {
            dispatch({
              type: 'Profil/addNotifications',
              payload: reponse.data.filter(
                item => item.participant_recepteur.id === monProfil.id && item.etat === false
              ),
            });
            nbreNotif.setNbre(
              reponse.data.filter(
                item => item.participant_recepteur.id === monProfil.id && item.etat === false
              ).length
            );
          });
        })
        .catch(() => {});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container fluid>
      <ErrorPopup message={msgError} open={openError} close={() => closeErrorHandle()} />
      {/* Modal confirmation réfuser demande */}
      <Modal
        className="d-flex align-items-center"
        show={openRefuserDemande}
        style={{ fontFamily: PoliceDefaut }}
      >
        <Modal.Header style={{ color: 'white', backgroundColor: '#134491' }}>
          <h4>Confirmation</h4>
        </Modal.Header>
        <form>
          <Modal.Body>
            Voulez-vous vraiment refuser cette demande ?
            <div className="d-flex justify-content-end mt-3">
              {/* <Button className='btn-recup' onClick={() => refuserDemandeRedux(accessToken, dispatch, selectInvitation, navigationPage, nbreNotif.setNbre, monProfil.id, setOpenRefuserDemande)}>Confirmer</Button> */}
              {circle ? (
                <CircularProgress />
              ) : (
                <Button
                  className="btn-recup"
                  onClick={() => refuserHandle(selectInvitation, selectNotif)}
                >
                  Confirmer
                </Button>
              )}

              <Button
                className="btn-recup2 mx-2"
                variant="secondary"
                onClick={() => {
                  setOpenRefuserDemande(false);
                  setSelectRdvItem(null);
                }}
              >
                Fermer
              </Button>
            </div>
          </Modal.Body>
        </form>
      </Modal>
      <Row className="">
        <Navigation
          button={false}
          titre={'Notifications'}
          icone={pictos.notification_rond_icone}
          photo={monProfil.photo_path}
          retour="dashboard"
          menus={true}
        />
      </Row>
      <Row className="p-0">
        <Chemin breadCrumbs={breadcrumbs_temp} />
      </Row>
      <div className="notification-filters">
        <button
          className={`notification-filter-btn ${selectedFilter === FILTER_ALL ? 'active' : 'inactive'}`}
          style={{ fontFamily: PoliceDefaut }}
          onClick={() => setSelectedFilter(FILTER_ALL)}
        >
          Tous
        </button>
        <button
          className={`notification-filter-btn ${selectedFilter === FILTER_UNREAD ? 'active' : 'inactive'}`}
          style={{ fontFamily: PoliceDefaut }}
          onClick={() => setSelectedFilter(FILTER_UNREAD)}
        >
          Non lu
        </button>
      </div>
      {loading ? (
        <div className="d-flex flex-column align-items-center justify-content-center py-5">
          <CircularProgress size={32} />
        </div>
      ) : (
        <Row className="container-contacts">
          {localNotifications.length !== 0 ? (
            localNotifications.map((item, index) => (
              <Row
                key={item.id || index}
                className={`contact-item d-flex justify-content-center ${item.etat ? 'notification-read' : ''}`}
                style={{
                  width: '500px',
                  ...(isNotificationRowClickable(item) ? { cursor: 'pointer' } : {}),
                }}
                onClick={
                  isNotificationRowClickable(item)
                    ? () => handleNotificationRowClick(item)
                    : undefined
                }
              >
                {item.type === 'INVITATION' ||
                (item.type === 'RELANCE_DEMANDE' && !item.data_target) ? (
                  <>
                    {(item.etat || item.type === 'RELANCE_DEMANDE') && (
                      <button
                        className="notification-archive-btn-icon"
                        onClick={e => {
                          e.stopPropagation();
                          archiveHandle(item.id);
                        }}
                        title="Archiver"
                      >
                        &times;
                      </button>
                    )}
                    <Col
                      sm="auto"
                      style={{ width: 'fit-content' }}
                      className="p-0 mx-2 photo-profil-contact d-flex align-items-center"
                    >
                      <Avatar
                        id="photoProfil"
                        className=""
                        src={item.participant_emeteur.photo}
                        style={{}}
                      />
                    </Col>

                    <Col className="p-1">
                      <Row className="">
                        <Col className="noms-participant">
                          {formatName(
                            item.participant_emeteur.prenom,
                            item.participant_emeteur.nom
                          )}
                        </Col>
                        <Col
                          sm="auto"
                          className="d-flex justify-content-end align-items-center mx-2 px-4"
                          style={{ fontSize: '.60rem', width: 'fit-content' }}
                        >
                          {moment(item.updated_at).fromNow()}
                        </Col>
                      </Row>
                      <Row>
                        <Col>{upperFirst(item.detail)}</Col>
                      </Row>
                      {item.choix === 'ALREADY_PROCESSED' ? (
                        <Row className="d-flex justify-content-end p-2">
                          <Col sm="auto" style={{ width: 'fit-content', padding: '0' }}>
                            <span className="badge-already-processed">Déjà traité</span>
                          </Col>
                        </Row>
                      ) : item.choix === 'ACCEPTED' ? (
                        <Row className="d-flex justify-content-end p-2">
                          <Col sm="auto" style={{ width: 'fit-content', padding: '0' }}>
                            <span className="badge-accepted">Accepté</span>
                          </Col>
                        </Row>
                      ) : item.choix === 'REFUSED' ? (
                        <Row className="d-flex justify-content-end p-2">
                          <Col sm="auto" style={{ width: 'fit-content', padding: '0' }}>
                            <span className="badge-refused">Refusé</span>
                          </Col>
                        </Row>
                      ) : (
                        <Row className="d-flex justify-content-end p-2">
                          <Col
                            sm="auto  d-flex justify-content-start"
                            style={{ width: 'fit-content', padding: '0' }}
                          >
                            <Button
                              style={{}}
                              className="btn-refuser p-0 px-2 py-1"
                              variant="outline-danger"
                              onClick={e => {
                                e.stopPropagation();
                                ouvrirRefuser(item.id_target, item.id, item);
                              }}
                            >
                              Refuser
                            </Button>
                          </Col>
                          <Col
                            sm="auto "
                            style={{ width: 'fit-content', padding: '0' }}
                            className="d-flex align-items-end mx-1"
                          >
                            <Button
                              className="btn-accepter p-0 px-2 py-1"
                              variant="outline"
                              onClick={e => {
                                e.stopPropagation();
                                item.data_target
                                  ? rdvAccepterHandle(item)
                                  : accepterHandle(item.id_target, item.id);
                              }}
                            >
                              Se connecter
                            </Button>
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </>
                ) : item.type === 'INVITATION_ACCEPTEE' ? (
                  <>
                    {(item.etat || item.type === 'RELANCE_DEMANDE') && (
                      <button
                        className="notification-archive-btn-icon"
                        onClick={e => {
                          e.stopPropagation();
                          archiveHandle(item.id);
                        }}
                        title="Archiver"
                      >
                        &times;
                      </button>
                    )}
                    <Row className="d-flex align-items-center">
                      <Col
                        sm="auto"
                        style={{ width: 'fit-content', marginRight: '7px' }}
                        className="p-0  photo-profil-contact d-flex align-items-center"
                      >
                        <Avatar
                          id="photoProfil"
                          className=""
                          style={{}}
                          src={item.participant_emeteur.photo}
                        ></Avatar>
                      </Col>
                      <Col sm="" className="p-1">
                        <Row>
                          <Col>
                            <b>
                              {formatName(
                                item.participant_emeteur.prenom,
                                item.participant_emeteur.nom
                              )}
                            </b>
                          </Col>
                          <Col
                            sm="auto"
                            className="d-flex justify-content-end align-items-center px-4"
                            style={{ fontSize: '.60rem', width: 'fit-content' }}
                          >
                            {moment(item.updated_at).fromNow()}
                          </Col>
                        </Row>
                        <Row>
                          <Col>{upperFirst(item.detail)}</Col>
                        </Row>

                        {!item.etat && (
                          <Row className="d-flex justify-content-end px-2">
                            <Col
                              sm="auto  d-flex justify-content-start"
                              style={{ width: 'fit-content', padding: '0' }}
                            >
                              <Button
                                className="py-1 mx-3 px-2 py-1"
                                variant="outline"
                                onClick={e => {
                                  e.stopPropagation();
                                  messageHandle(
                                    item.participant_emeteur.nom,
                                    item.participant_emeteur.prenom,
                                    item.participant_emeteur.fonction,
                                    item.id_target,
                                    item.participant_emeteur.photo,
                                    item.participant_emeteur.organisation.nom,
                                    item.participant_emeteur.organisation.logo,
                                    item.room,
                                    item.id,
                                    item.participant_emeteur.from_structure
                                  );
                                }}
                              >
                                Message
                              </Button>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </>
                ) : item.type === 'MESSAGE' ? (
                  <>
                    {(item.etat || item.type === 'RELANCE_DEMANDE') && (
                      <button
                        className="notification-archive-btn-icon"
                        onClick={e => {
                          e.stopPropagation();
                          archiveHandle(item.id);
                        }}
                        title="Archiver"
                      >
                        &times;
                      </button>
                    )}
                    <Col
                      sm="auto"
                      style={{ width: 'fit-content' }}
                      className="p-0 mx-2 photo-profil-contact d-flex align-items-center"
                    >
                      <Avatar
                        id="photoProfil"
                        className=""
                        src={item.participant_emeteur.photo}
                        style={{}}
                      />
                    </Col>

                    <Col className="p-1">
                      <Row className="">
                        <Col className="noms-participant">
                          {`${upperFirst(
                            item.participant_emeteur.prenom.toLowerCase()
                          )} ${upperFirst(item.participant_emeteur.nom.toLowerCase())}`}
                        </Col>
                        <Col
                          sm="auto"
                          className="d-flex justify-content-end align-items-center mx-2"
                          style={{ fontSize: '.60rem', width: 'fit-content' }}
                        >
                          {moment(item.updated_at).fromNow()}
                        </Col>
                      </Row>
                      <Row>
                        <Col>{upperFirst(item.detail)}</Col>
                      </Row>
                      {!item.etat && (
                        <Row className="d-flex justify-content-end px-2">
                          <Col
                            sm="auto  d-flex justify-content-start"
                            style={{ width: 'fit-content', padding: '0' }}
                          >
                            <Button
                              className="mx-3 px-2 py-1"
                              variant="outline"
                              onClick={e => {
                                e.stopPropagation();
                                messageHandle(
                                  item.participant_emeteur.nom,
                                  item.participant_emeteur.prenom,
                                  item.participant_emeteur.fonction,
                                  item.id_target,
                                  item.participant_emeteur.photo,
                                  item.participant_emeteur.organisation.nom,
                                  item.participant_emeteur.organisation.logo,
                                  item.room,
                                  item.id,
                                  item.participant_emeteur.from_structure
                                );
                              }}
                            >
                              Message
                            </Button>
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </>
                ) : item.type === 'DEMANDE_RENDEZ_VOUS' ||
                  (item.type === 'RELANCE_DEMANDE' && item.data_target) ? (
                  <>
                    {(item.etat || item.type === 'RELANCE_DEMANDE') && (
                      <button
                        className="notification-archive-btn-icon"
                        onClick={e => {
                          e.stopPropagation();
                          archiveHandle(item.id);
                        }}
                        title="Archiver"
                      >
                        &times;
                      </button>
                    )}
                    <Col
                      sm="auto"
                      style={{ width: 'fit-content' }}
                      className="p-0 mx-2 photo-profil-contact d-flex align-items-center"
                    >
                      <Avatar
                        id="photoProfil"
                        className=""
                        src={item.participant_emeteur.photo}
                        style={{}}
                      />
                    </Col>

                    <Col className="p-1">
                      <Row className="">
                        <Col className="noms-participant">
                          {formatName(
                            item.participant_emeteur.prenom,
                            item.participant_emeteur.nom
                          )}
                        </Col>
                        <Col
                          sm="auto"
                          className="d-flex justify-content-end align-items-center mx-2"
                          style={{ fontSize: '.60rem', width: 'fit-content' }}
                        >
                          {moment(item.updated_at).fromNow()}
                        </Col>
                      </Row>
                      <Row>
                        <Col>{item.detail}</Col>
                      </Row>
                      {/* "indisponible" = info only, no choice */}
                      {item.detail !== 'est indisponible pour ce rendez-vous' &&
                        (item.choix === 'ALREADY_PROCESSED' ? (
                          <Row className="d-flex justify-content-end p-2">
                            <Col sm="auto" style={{ width: 'fit-content', padding: '0' }}>
                              <span className="badge-already-processed">Déjà traité</span>
                            </Col>
                          </Row>
                        ) : item.choix === 'ACCEPTED' ? (
                          <Row className="d-flex justify-content-end p-2">
                            <Col sm="auto" style={{ width: 'fit-content', padding: '0' }}>
                              <span className="badge-accepted">Accepté</span>
                            </Col>
                          </Row>
                        ) : item.choix === 'REFUSED' ? (
                          <Row className="d-flex justify-content-end p-2">
                            <Col sm="auto" style={{ width: 'fit-content', padding: '0' }}>
                              <span className="badge-refused">Refusé</span>
                            </Col>
                          </Row>
                        ) : (
                          <Row className="d-flex justify-content-end p-2">
                            <Col
                              sm="auto d-flex justify-content-start"
                              style={{ width: 'fit-content', padding: '0' }}
                            >
                              <Button
                                className="btn-refuser p-0 px-2 py-1"
                                variant="outline-danger"
                                onClick={e => {
                                  e.stopPropagation();
                                  ouvrirRefuser(item.id_target, item.id, item);
                                }}
                              >
                                Refuser
                              </Button>
                            </Col>
                            <Col
                              sm="auto"
                              style={{ width: 'fit-content', padding: '0' }}
                              className="d-flex align-items-end mx-1"
                            >
                              <Button
                                className="btn-accepter p-0 px-2 py-1"
                                variant="outline"
                                onClick={e => {
                                  e.stopPropagation();
                                  item.data_target
                                    ? rdvAccepterHandle(item)
                                    : accepterHandle(item.id_target, item.id);
                                }}
                              >
                                Accepter
                              </Button>
                            </Col>
                          </Row>
                        ))}
                    </Col>
                  </>
                ) : (
                  <>
                    <button
                      className="notification-archive-btn-icon"
                      onClick={e => {
                        e.stopPropagation();
                        archiveHandle(item.id);
                      }}
                      title="Archiver"
                    >
                      &times;
                    </button>
                    <Col
                      sm="auto"
                      style={{ width: 'fit-content' }}
                      className="p-0 mx-2 photo-profil-contact d-flex align-items-center"
                    >
                      <Avatar
                        id="photoProfil"
                        className=""
                        src={item.participant_emeteur.photo}
                        style={{}}
                      />
                    </Col>

                    <Col className="p-1">
                      <Row className="">
                        <Col className="noms-participant">
                          {formatName(
                            item.participant_emeteur.prenom,
                            item.participant_emeteur.nom
                          )}
                        </Col>
                        <Col
                          className="d-flex justify-content-end align-items-center mx-2"
                          style={{ fontSize: '.60rem', width: 'fit-content' }}
                        >
                          {moment(item.updated_at).fromNow()}
                        </Col>
                      </Row>
                      <Row>
                        <Col>{item.detail}</Col>
                      </Row>
                    </Col>
                  </>
                )}
              </Row>
            ))
          ) : (
            <p
              className="h4"
              style={{
                fontFamily: PoliceDefaut,
                textAlign: 'center',
                color: '#134491',
                fontSize: '150%',
              }}
            >
              Pas de nouvelle notification
            </p>
          )}
        </Row>
      )}
    </Container>
  );
};

export default NotificationsPage;
